import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store' 
import VueAwesomeSwiper from 'vue-awesome-swiper';  
import 'swiper/dist/css/swiper.min.css'; // 确保引入正确的CSS文件路径  swiper-bundle.css
import '@/assets/css/common.css'
import '@/assets/css/index.css'
/* main.js引入iconfont.css */
import "../src/assets/font_icon/iconfont.css"
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper);  
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
